import React from 'react';

/**
 * Sprunglink zum Hauptinhalt (erstes fokussierbares Element der oeffentlichen
 * Seiten). Unsichtbar, bis er per Tastatur fokussiert wird.
 *
 * Bis Oktober 2026 lagen hier auch AccessibilityProvider, Announcer,
 * TouchFeedback und SwipeIndicator der alten Landingpage — und ein zweiter
 * Sprunglink auf #navigation, ein Ziel, das es nie gab. Nur noch in der
 * Git-Historie.
 */
const SkipLink = ({ targetId, children }) => {
  const handleClick = (e) => {
    e.preventDefault();
    const target = document.getElementById(targetId);
    if (target) {
      target.focus();
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <a
      href={`#${targetId}`}
      onClick={handleClick}
      className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-50 focus:bg-cta focus:text-cta-foreground focus:px-4 focus:py-2 focus:rounded-xl focus:shadow-token-lg"
    >
      {children}
    </a>
  );
};

export { SkipLink };
